// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"566":"45692589","973":"73e8aab3"}[chunkId] + ".chunk.css";
};